import React from 'react';
import { useHistory } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';

const GoalMenu = () => {
  const history = useHistory();

  const menus: MenuItem[] = [
    { text: '목표', value: '/goals' },
    { text: '목표카테고리', value: '/goal-categories' },
  ];

  const _click = (menu: MenuItem) => {
    history.push(menu.value);
  };
  return (
    <>
      <Menu fluid secondary vertical>
        {menus.map((menu) => (
          <Menu.Item
            key={menu.value}
            active={menu.value === window.location.pathname}
            onClick={() => _click(menu)}
          >
            {menu.text}
          </Menu.Item>
        ))}
      </Menu>
    </>
  );
};

export default GoalMenu;

type MenuItem = { text: string; value: string };
